<template>
    <Teleport to="body">
        <div class="modal fade" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body">
                        <div class="t:center p:32|0">
                            <div class="f:32@xl f:24@sm f:20@<sm">
                                <div class="f:24">請在框框內簽名</div>
                                <div class="mt:40! m:0|56 {m:0}@<sm">
                                    <div class="b:1|solid|gray04 r:8 h:221 rel {content:attr(data-label);abs;left:50%;top:50%;translate(-50%,-50%);color:gray03;f:16}::after" data-label="簽名處" ref="container">
                                        <canvas></canvas>
                                    </div>
                                </div>
                            </div>
                            <div class="mt:42 flex jc:center gap:32 flex:wrap">
                                <button class="btn btn-outline-secondary color:gray03" @click="clearHandler()" type="button">清除</button>
                                <button class="btn btn-primary" data-bs-dismiss="modal" @click="submitHandler()" :disabled="empty" type="button">送出</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const { useElementSize } = VueUse;

    const root = ref();
    const container = ref();
    const emit = defineEmits(["submit"]);
    const { width, height } = useElementSize(container);
    const empty = ref(true);

    let modal;
    let signaturePad;

    const clearHandler = () => {
        if (signaturePad) {
            empty.value = true;

            signaturePad.clear();
        }
    };

    const submitHandler = () => {
        if (signaturePad) {
            emit("submit", signaturePad.toDataURL());
        }
    };

    const shownHandler = () => {
        if (!signaturePad) {
            const canvas = document.querySelector("canvas");
            canvas.width = width.value;
            canvas.height = height.value;

            signaturePad = new SignaturePad(canvas);
            signaturePad.addEventListener("beginStroke", () => empty.value = false);
        }
    };

    defineExpose({
        show: () => modal.show(),
        hide: () => modal.hide()
    });

    onMounted(() => {
        const el = root.value;

        modal = new bootstrap.Modal(el, { keyboard: false });

        el.addEventListener("shown.bs.modal", shownHandler);
        el.addEventListener("hidden.bs.modal", clearHandler);
    });
</script>
